import { render, staticRenderFns } from "./questionChoices.vue?vue&type=template&id=8c306134&"
import script from "./questionChoices.vue?vue&type=script&lang=js&"
export * from "./questionChoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports